import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { Grid, TextField, IconButton, Tooltip } from "@material-ui/core";
import SectionCard from "./SectionCard";
import CurrencySelect from "./CurrencySelect";
import { useCurrencies } from "./useCurrencies";

const SubAgentCredits: React.FC = () => {
  const { values, handleChange, setFieldValue } = useFormikContext<any>();
  const { currencies, loading, getDefaultId } = useCurrencies();
  const rows = values.balanceRequests ?? [];

  useEffect(() => {
    if (!currencies) return;
    if (!Array.isArray(values.balanceRequests) || values.balanceRequests.length === 0) {
      setFieldValue("balanceRequests", [
        { creditLimit: 0, neto: 0, minimumTicketPrice: 0, currencyId: getDefaultId() },
      ]);
    } else {
      const patched = values.balanceRequests.map((r: any) => ({
        ...r,
        currencyId: r?.currencyId ?? getDefaultId(),
      }));
      setFieldValue("balanceRequests", patched);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencies]);

  const addRow = () =>
    setFieldValue("balanceRequests", [
      ...(values.balanceRequests ?? []),
      { creditLimit: 0, neto: 0, minimumTicketPrice: 0, currencyId: getDefaultId() },
    ]);

  const removeRow = (idx: number) =>
    setFieldValue(
      "balanceRequests",
      (values.balanceRequests ?? []).filter((_: any, i: number) => i !== idx)
    );

  return (
    <SectionCard title="Credits & Currency">
      {(rows.length ? rows : [{}]).map((r: any, idx: number) => (
        <Grid container spacing={2} key={idx} alignItems="center" style={{ marginBottom: 8 }}>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              fullWidth
              name={`balanceRequests[${idx}].creditLimit`}
              label="Credit limit"
              value={rows[idx]?.creditLimit ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              fullWidth
              name={`balanceRequests[${idx}].neto`}
              label="Neto"
              value={rows[idx]?.neto ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              fullWidth
              name={`balanceRequests[${idx}].minimumTicketPrice`}
              label="Minimum Ticket Price"
              value={rows[idx]?.minimumTicketPrice ?? 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <CurrencySelect
              name={`balanceRequests[${idx}].currencyId`}
              label="Currency"
              value={rows[idx]?.currencyId}
              onChange={handleChange}
              currencies={currencies}
              loading={loading}
            />
          </Grid>
        </Grid>
      ))}

    </SectionCard>
  );
};

export default SubAgentCredits;
